import "../global";
import { PageAttributesExtractor } from "../shared/PageAttributesExtractor";
import { PageDebugInfo } from "../shared/PageDebugInfo";
import { TouTvPageAttributes } from "./models/TouTvPageAttributes";
import { getSanitizedDataLayerValue } from "../shared/DataLayerHelper";
import { GeoIpService } from "../shared/geoLocation/GeoIpService";
import { inject, injectable, singleton } from "tsyringe";
import { CmpService } from "../cmp/CmpService";

@injectable()
@singleton()
export class ToutvPageAttributesExtractor implements PageAttributesExtractor {
  constructor(
    @inject(GeoIpService) private geoIpService: GeoIpService,
    @inject(CmpService) private cmpService: CmpService,
  ) {}

  /**
   * @inheritdoc
   */
  public extractAttributes(): TouTvPageAttributes {
    return {
      application: getSanitizedDataLayerValue("app.name"),
      audience: getSanitizedDataLayerValue("show.audience.principal"),
      channel: getSanitizedDataLayerValue("distribution.channels.ott.principal"),
      CMP_targetedAds: this.cmpService.UserConsent.targetedAds,
      CMP_targetedContent: this.cmpService.UserConsent.targetedContent,
      codeName: getSanitizedDataLayerValue("show.codeName"),
      distributionTier: getSanitizedDataLayerValue("distribution.tier"),
      episode: getSanitizedDataLayerValue("content.episode"),
      familyFriendly: getSanitizedDataLayerValue("show.isFamilyFriendly"),
      format: getSanitizedDataLayerValue("show.format"),
      genre: getSanitizedDataLayerValue("show.genres.principal"),
      season: getSanitizedDataLayerValue("content.season"),
      subject: getSanitizedDataLayerValue("show.subjects.principal"),
      typeContenu: getSanitizedDataLayerValue("show.contentType"),
      distributionMode: getSanitizedDataLayerValue("distribution.mode"),
      eventName: getSanitizedDataLayerValue("page.hierarchy2"),
      subjectLevel1: getSanitizedDataLayerValue("content.subjects.level1"),
      subjectLevel2: getSanitizedDataLayerValue("content.subjects.level2"),
      station: getSanitizedDataLayerValue("distribution.channels.station"),
      collectionNames: getSanitizedDataLayerValue("content.collectionNames"),
    };
  }

  /**
   * @inheritdoc
   */
  public extractPageLoadedAttributes(): TouTvPageAttributes {
    return this.extractAttributes();
  }

  /**
   * @inheritdoc
   */
  public extractReadAttributes(): TouTvPageAttributes {
    // Tou.tv doesn't have a read event
    throw new Error("Method not implemented.");
  }

  /**
   * @inheritdoc
   */
  public extractDebugInfo(): PageDebugInfo {
    return {
      pageAppId: dataLayerHelper.get<string>("app.name"),
      pageVersion: dataLayerHelper.get<string>("app.id"),
    };
  }

  /**
   * @inheritdoc
   */
  public async extractStartSessionAttributes(): Promise<TouTvPageAttributes> {
    const attributes = this.extractAttributes();
    const postalCode = await this.geoIpService.fetchAndStoreUserPostalCode();
    if (postalCode) {
      attributes.postalCode = postalCode;
      attributes.fsa = postalCode.substring(0, 3);
    } else {
      attributes.fsa = getSanitizedDataLayerValue("device.geo.fsa");
    }
    return attributes;
  }

  /**
   * @inheritdoc
   */
  extractStreamAttributes(): TouTvPageAttributes {
    // For now, it's the same attributes, but the payload could change in the future.
    return this.extractAttributes();
  }
}
